export default __webpack_public_path__ + "static/media/includeImg4.914bcfd5.jpg";